<template>
	<div v-if="visible" class="hi-loading-overlay">
		<div class="hi-loading-title">信之家</div>
		<div class="loader-container">
			<canvas ref="canvasRef"></canvas>
			<div class="percentage-text">{{ displayPercent }}%</div>
			<div class="loading-text">{{ message }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HiLoading',
		data() {
			return {
				visible: false,
				message: '',
				progress: 0, // 当前进度 0-100
				targetProgress: 0, // 目标进度
				animationId: null,
				canvasContext: null,
				canvasSize: {
					width: 0,
					height: 0
				},
			}
		},
		computed: {
			displayPercent() {
				return Math.round(this.progress)
			}
		},
		methods: {
			show(msg = 'LOADING...') {
				this.message = msg
				this.progress = 0
				this.targetProgress = 95 // 自动涨到 95% 等待
				if (!this.visible) {
					this.visible = true
					this.$nextTick(() => {
						this.initCanvas()
						if (!this.animationId) this.startAnimation()
					})
				}
			},
			hide() {
				// 让进度快速冲到 100%
				this.targetProgress = 100
			},
			initCanvas() {
				const canvas = this.$refs.canvasRef
				if (!canvas) return
				const container = this.$el.querySelector('.loader-container')
				const rect = container.getBoundingClientRect()
				const dpr = window.devicePixelRatio || 1
				canvas.width = rect.width * dpr
				canvas.height = rect.height * dpr
				canvas.style.width = rect.width + 'px'
				canvas.style.height = rect.height + 'px'
				const ctx = canvas.getContext('2d')
				ctx.scale(dpr, dpr)
				this.canvasContext = ctx
				this.canvasSize = {
					width: rect.width,
					height: rect.height
				}
			},
			startAnimation() {
				const loop = () => {
					if (!this.visible) {
						this.animationId = null
						return
					}

					// 平滑逼近目标进度
					if (Math.abs(this.progress - this.targetProgress) > 0.1) {
						// 接近100时加速，否则正常速度
						const speed = this.targetProgress === 100 ? 0.12 : 0.05
						this.progress += (this.targetProgress - this.progress) * speed
					} else {
						this.progress = this.targetProgress
					}

					// 如果已经达到 100% 并且目标也是 100，短暂停留后隐藏
					if (this.targetProgress === 100 && this.progress >= 99.9) {
						this.progress = 100
						this.drawWaves()
						// 停留 300ms 让用户看到 100%
						setTimeout(() => {
							if (this.targetProgress === 100) {
								this.visible = false
								this.animationId = null
								return
							}
						}, 300)
					}

					this.drawWaves()
					this.animationId = requestAnimationFrame(loop)
				}
				loop()
			},
			drawWaves() {
				const ctx = this.canvasContext
				if (!ctx) return
				const {
					width,
					height
				} = this.canvasSize
				ctx.clearRect(0, 0, width, height)

				// 水位高度：progress=0 时波浪在底部，100 时在顶部
				const waterLevel = height * (1 - this.progress / 100)
				const time = Date.now() * 0.005

				// 双层波浪
				this.drawWave(ctx, waterLevel, width, height, time * 0.8, '#ffbe40', 15, 0.02)
				this.drawWave(ctx, waterLevel, width, height, time * 1.2, '#ffd351', 10, 0.025)
			},
			drawWave(ctx, waterY, w, h, offset, color, amplitude, frequency) {
				ctx.beginPath()
				ctx.fillStyle = color
				ctx.moveTo(0, waterY)
				for (let x = 0; x <= w; x++) {
					const y = waterY + amplitude * Math.sin(frequency * x + offset)
					ctx.lineTo(x, y)
				}
				ctx.lineTo(w, h)
				ctx.lineTo(0, h)
				ctx.closePath()
				ctx.fill()
			},
		},
		beforeUnmount() {
			if (this.animationId) {
				cancelAnimationFrame(this.animationId)
				this.animationId = null
			}
		},
		expose: ['show', 'hide'],
	}
</script>

<style scoped>
	.hi-loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #ff4757;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
	}
	
	/* 标题 */
	.hi-loading-title {
		position: absolute;
		top: calc(50vh - 240px);
		color: #fff;
		font-size: 2rem;
		font-weight: 600;
		letter-spacing: 10px;
	}

	.loader-container {
		position: relative;
		width: 280px;
		height: 280px;
		border-radius: 50%;
		background-color: #ff9f43;
		overflow: hidden;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
	}

	canvas {
		position: absolute;
		top: 0;
		left: 0;
	}

	.percentage-text {
		position: absolute;
		top: 45%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 48px;
		font-weight: bold;
		color: white;
		z-index: 2;
		text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
	}

	.loading-text {
		position: absolute;
		top: 58%;
		left: 50%;
		transform: translateX(-50%);
		font-size: 18px;
		color: white;
		z-index: 2;
		white-space: nowrap;
		text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
	}
</style>